module.exports = __webpack_public_path__ + "static/img/day-5.043cc61.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/day-5.png
// module id = XcuE
// module chunks = 1